/* unplugin-vue-components disabled */import script from "./DraggableContainer.vue?vue&type=script&setup=true&lang=js"
export * from "./DraggableContainer.vue?vue&type=script&setup=true&lang=js"

import "./DraggableContainer.vue?vue&type=style&index=0&id=906a3430&scoped=true&lang=less"

import exportComponent from "/Users/zhangxuan/Documents/Projects/VinesDjango/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-906a3430"]])

export default __exports__